import React from 'react';
import { SectionReveal } from './SectionReveal';
interface SectionHeadProps {
  index: string;
  kicker: string;
  title: string;
  intro: string;
}

/**
 * The shared editorial section header: a numbered kicker in the left
 * column, the statement and standfirst in the right.
 */
export function SectionHead({
  index,
  kicker,
  title,
  intro
}: SectionHeadProps) {
  return <SectionReveal data-id="element-160" data-mp="3lgx2mszaywcq">
      <div className="grid grid-cols-1 items-start gap-3.5 md:grid-cols-[180px_1fr] md:gap-x-[clamp(20px,4vw,56px)]" data-id="element-161" data-mp="3lh6rueciwzhd">
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-162" data-mp="3gj58rtf3l05w">
          {index}
          <span className="pl-2" data-id="element-163" data-mp="3bhftu2or82cj">{kicker}</span>
        </p>
        <div data-id="element-164" data-mp="37hffsj5kht60">
          <h2 className="font-serif text-[clamp(28px,3.9vw,46px)] font-medium leading-[1.08] tracking-[-0.02em]" data-id="element-165" data-mp="37hxbneobi5de">
            {title}
          </h2>
          <p className="mt-[18px] max-w-[52ch] text-ink-70" data-id="element-166" data-mp="201hfpkepyq4g">{intro}</p>
        </div>
      </div>
    </SectionReveal>;
}